import { useState } from "react";
import { CsvSchema, fetchCsvTemplates, CsvTemplateCommon } from "../services/csvSettingsService";

export function useCsvTemplateSelection(
  value: CsvSchema,
  onChange: (value: CsvSchema) => void,
  hasSlipTypeSupport: boolean,
  selectedSlipType: string | null,
  activeCsvSchema: CsvSchema,
  handleActiveCsvChange: (value: CsvSchema) => void
) {
  const [templates, setTemplates] = useState<CsvTemplateCommon[]>([]);
  const [templateModalOpen, setTemplateModalOpen] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState<string | null>(null);
  const [fetchingTemplates, setFetchingTemplates] = useState(false);

  // テンプレート一覧を取得
  const loadTemplates = async () => {
    setFetchingTemplates(true);
    try {
      const data = await fetchCsvTemplates();
      setTemplates(data);
    } catch (error) {
      console.error("Failed to fetch templates:", error);
    } finally {
      setFetchingTemplates(false);
    }
  };

  const handleApplyTemplate = () => {
    const template = templates.find((t) => t.id === selectedTemplateId);
    if (!template) return;

    // 伝票種別タブが有効かどうかで適用先を切り替える
    const isSlipTypeTarget =
      hasSlipTypeSupport && selectedSlipType && selectedSlipType !== "__default__";
    const currentColumns = isSlipTypeTarget ? activeCsvSchema.columns : value.columns;

    if (
      currentColumns.length > 0 &&
      !confirm("現在の設定を上書きしてテンプレートを適用しますか？")
    ) {
      return;
    }

    const newSchema: CsvSchema = {
      templateId: template.id,
      encoding: template.encoding,
      columns: template.columns.map((col) => ({
        ...col,
        jsonPath: "", // テンプレートからはパスとデフォルト値をコピーしない（枠だけコピー）
        defaultValue: "",
      })),
    };

    // 伝票種別が選択中ならその種別のCSV設定に、そうでなければベース設定に適用
    if (isSlipTypeTarget) {
      handleActiveCsvChange(newSchema);
    } else {
      onChange(newSchema);
    }
    setTemplateModalOpen(false);
  };

  return {
    templates,
    templateModalOpen,
    setTemplateModalOpen,
    selectedTemplateId,
    setSelectedTemplateId,
    fetchingTemplates,
    loadTemplates,
    handleApplyTemplate,
  };
}
